import { useConfig } from './use-config'

export interface ConfigProps {
	keys: string[]
	children?: (values: unknown[]) => React.ReactNode
	render?: (values: unknown[]) => React.ReactNode
	alwaysRender?: boolean
	loading?: JSX.Element
}

export function Config({
	keys,
	children,
	render,
	alwaysRender,
	loading,
}: ConfigProps): React.ReactNode {
	const results = useConfig<[any]>(keys)
	const hasAllValues = !keys || results?.length === keys.length

	if (!alwaysRender && !hasAllValues) {
		return loading ?? null
	}

	if (render) {
		return render(results) ?? null
	}

	if (children) {
		return children(results) ?? null
	}

	return null
}
